export const quartersList = ["Q1", "Q2", "Q3", "Q4"];
export const quarterToMonths = {
  Q1: ["Apr", "May", "Jun"],
  Q2: ["Jul", "Aug", "Sep"],
  Q3: ["Oct", "Nov", "Dec"],
  Q4: ["Jan", "Feb", "Mar"],
};

export const checkCurrentFinancialYear = () => {
  const today = new Date();
  const year = today.getFullYear();
  const month = today.getMonth() + 1;
  return month >= 4 ? `${year}-${year + 1}` : `${year - 1}-${year}`;
};

export const formatFinancialYears = async (response) => {
  let fy = response
    ?.map((item) => ({
      id: String(item.id),
      value: item.fn.replace(/\s/g, ""),
    }))
    .sort((a, b) => Number(b.id) - Number(a.id));

  fy = [{ id: "0", value: "" }, ...(fy || [])];
  return fy;
};

export const getGridColumnTotal = (data, activePage, limit, key) => {
  return isNaN(
    data
      ?.slice((activePage - 1) * limit, activePage * limit)
      .reduce((sum, val) => sum + parseFloat(val[key]), 0)
      .toFixed(2),
  )
    ? 0.0
    : data
        ?.slice((activePage - 1) * limit, activePage * limit)
        .reduce((sum, val) => sum + parseFloat(val[key]), 0)
        .toFixed(2);
};

export const formatTotalRow = (row, value, index, isBold) => {
  const cell = row.getCell(index);
  cell.value =
    (value === "" || isNaN(value)) && value !== "TOTAL" ? "0.00" : value;
  if (typeof value === "number" || !isNaN(value)) {
    cell.alignment = { horizontal: "right", vertical: "middle" };
  } else {
    cell.alignment = { horizontal: "center", vertical: "middle" };
  }

  isBold === true
    ? (cell.font = { bold: "true", size: "10" })
    : (cell.font = { size: "10" });
  cell.numFmt = "#,##0.00";
  return cell;
};

export const getMonthsForQuarters = (...quarters) => {
  return quarters.flatMap((q) => quarterToMonths[q] || []);
};

export const getLastDateOfMonth = (monthStr, financialYearStr) => {
  const monthMap = {
    jan: 0,
    feb: 1,
    mar: 2,
    apr: 3,
    may: 4,
    jun: 5,
    jul: 6,
    aug: 7,
    sep: 8,
    oct: 9,
    nov: 10,
    dec: 11,
  };

  if (!monthStr || !financialYearStr) return null;

  const month = monthStr.toLowerCase();
  const monthIndex = monthMap[month];
  if (monthIndex === undefined) return null;

  const [startYear, endYear] = financialYearStr.split("-").map(Number);

  let year;
  if (monthIndex >= 3) {
    // Apr (3) to Dec (11) → belongs to startYear
    year = startYear;
  } else {
    // Jan (0) to Mar (2) → belongs to endYear
    year = endYear;
  }

  const lastDate = new Date(year, monthIndex + 1, 0);
  const dd = String(lastDate.getDate()).padStart(2, "0");
  const mm = String(lastDate.getMonth() + 1).padStart(2, "0"); // Month is 0-based
  const yyyy = lastDate.getFullYear();

  return `${dd}-${mm}-${yyyy}`;
};

export const getPreviousMonthAndFY = async (
  financialYear,
  currentMonthShort,
  financialYearsArray,
) => {
  const months = [
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
    "Jan",
    "Feb",
    "Mar",
  ];
  const index = months.indexOf(currentMonthShort);

  if (index === -1) {
    throw new Error("Invalid month. Use format like 'Jan', 'Feb', etc.");
  }

  const prevIndex = (index - 1 + 12) % 12;
  const prevMonth = months[prevIndex];

  let [startYear, endYear] = financialYear.split("-").map(Number);
  if (currentMonthShort === "Apr") {
    startYear -= 1;
    endYear -= 1;
  }

  const updatedFY = `${startYear} - ${endYear}`;

  const normalizedUpdatedFY = updatedFY.replace(/\s/g, "");
  const matched = financialYearsArray.find(
    (fy) => fy.value.replace(/\s/g, "") === normalizedUpdatedFY,
  );
  const financialYearId = matched?.id || null;

  return {
    financialYear: updatedFY,
    month: prevMonth,
    financialYearId,
  };
};
export const isSeniorCitizen = (dob, financialYear) => {
  const birthDate = new Date(dob);

  const parts = financialYear.split("-");
  const fyEndYear =
    parts[1].length === 2
      ? 2000 + parseInt(parts[1], 10)
      : parseInt(parts[1], 10);

  const fyEndDate = new Date(`${fyEndYear}-03-31`);

  let age = fyEndDate.getFullYear() - birthDate.getFullYear();

  if (
    fyEndDate.getMonth() < birthDate.getMonth() ||
    (fyEndDate.getMonth() === birthDate.getMonth() &&
      fyEndDate.getDate() < birthDate.getDate())
  ) {
    age--;
  }

  console.log("Age:", age);

  return age >= 60;
};

export const isDataSentToCA = (dataArray, key = "ie", value = 1) => {
  return !dataArray.some((el) => el[key] === value);
};

export const isDataReviewByCA = (dataArray, key = "su", value = 1) => {
  return dataArray.some((el) => el[key] === value);
};

export const form24QFields = [
  {
    label: "Employee Name",
    key: "en",
    width: "200px",
    //className: "sticky-col col-3",
  },
  { label: "PAN", key: "pa", width: "150px" }, //className: "sticky-col col-4"
  { label: "Aadhar Number", key: "adn", width: "160px" },
  { label: "Designation", key: "de", width: "120px" },
  { label: "Dob (dd-mm-yyy)", key: "ed", width: "130px" },
  { label: "Age", key: "age", width: "130px" },
  { label: "Gender", key: "eg", width: "150px" },
  { label: "Address", key: "ead", width: "150px" },
  { label: "City", key: "ec", width: "120px" },
  { label: "State", key: "es", width: "120px" },
  { label: "PinCode", key: "epc", width: "140px" },
  { label: "Country", key: "eco", width: "140px" },
  { label: "New Tax Reg.", key: "nt", width: "100px" },

  { label: "Basic", key: "ba", width: "120px" },
  { label: "Grade Pay", key: "gp", width: "120px" },
  { label: "D.A.", key: "da", width: "120px" },
  { label: "H.R.A.", key: "hr", width: "120px" },
  { label: "C.C.A.", key: "ca", width: "120px" },
  { label: "Other Salary", key: "os", width: "120px" },
  { label: "Bonus", key: "bo", width: "120px" },
  { label: "Arrear", key: "ar", width: "120px" },
  { label: "Total", key: "totalBasic", width: "130px" },

  { label: "G.P.F.", key: "gpf", width: "120px" },
  { label: "G.P.F. Advance Deduction", key: "gpfad", width: "120px" },
  { label: "G.I.S.", key: "gis", width: "120px" },
  { label: "HRA Deduction", key: "hrad", width: "120px" },
  { label: "Vehical Deduction", key: "vcld", width: "120px" },
  { label: "Income Tax", key: "it", width: "150px" },
  { label: "Total Deduction", key: "td", width: "150px" },
  { label: "Net Pay Salary", key: "na", width: "150px" },
  { label: "Voucher Amount", key: "va", width: "150px" },
  { label: "Voucher Number", key: "vn", width: "150px" },
  { label: "Date", key: "ddd", width: "150px" },

  //database fields required
  { label: "Other Allowances", key: "aa1", width: "180px" },
  { label: "Employer's Contribution", key: "emc", width: "320px" },
  { label: "Medical Reimbursement", key: "mr", width: "320px" },
  { label: "Total Rent Paid", key: "rp", width: "320px" },
  { label: "Saving Interest", key: "si", width: "320px" },
  { label: "Fdr Interest", key: "fdi", width: "320px" },
  { label: "NSC Interest", key: "nsci", width: "320px" },
  { label: "Family Pension Income", key: "fpi", width: "320px" },
  { label: "Any Other Income", key: "an1", width: "320px" },

  { label: "GPF Total", key: "gpfTotal", width: "320px" },
  { label: "GIS Total", key: "gisTotal", width: "320px" },
  { label: "Emp Contri. Total", key: "empContTotal", width: "320px" },
  { label: "PPF", key: "ppf", width: "120px" },
  { label: "LIC", key: "lic", width: "120px" },
  { label: "Tuition Fees", key: "tf", width: "150px" },
  { label: "House Loan Principle", key: "hp", width: "180px" },
  { label: "House Loan Interest", key: "ad2", width: "180px" },
  { label: "P.L.I.", key: "pi", width: "120px" },
  { label: "Term Insurance", key: "ti", width: "150px" },
  { label: "Employer's Contri. (NPS)", key: "nps", width: "320px" },
  { label: "Any Other Deduction", key: "ad1", width: "180px" },
  { label: "Total Deduction u/s 80C", key: "totalDeduction", width: "180px" },

  { label: "Standard Disability", key: "sd", width: "150px" },
  { label: "Severe Disability", key: "svd", width: "150px" },

  { label: "Deduction u/s 80D (S)", key: "80ds", width: "150px" },
  { label: "Deduction u/s 80D (F)", key: "80df", width: "150px" },
  { label: "Deduction u/s 80DD", key: "80dd", width: "150px" },
  { label: "Deduction u/s 80DDB", key: "80ddb", width: "150px" },
  { label: "Deduction u/s 80E", key: "80e", width: "150px" },
  { label: "Deduction u/s 80G", key: "80g", width: "150px" },
  { label: "50% 80G Deduction", key: "g50", width: "150px" },
  { label: "100% 80G Deduction", key: "g100", width: "150px" },
  { label: "Deduction u/s 80TTA", key: "80tta", width: "150px" },
  { label: "Deduction u/s 80TTB", key: "80ttb", width: "150px" },
  { label: "Deduction u/s 80U", key: "80u", width: "150px" },
  { label: "Deduction u/s 80CCD 1B", key: "80b", width: "220px" },
  { label: "N.P.S. u/s 80CCD(1)", key: "ccd", width: "320px" },
  { label: "Deduction u/s 80 CCH(2)", key: "80cch2", width: "320px" },
  { label: "Total Other Deduction", key: "totalOtherDeduc", width: "320px" },

  // { label: "If Any Other Income", key: "an2", width: "180px" },
  // { label: "Total Other Income", key: "toi", width: "180px", display: "none" }, //display: "none" used for parmanent hide || "" for show

  // { label: "If Any Other Income", key: "aa2", width: "180px" },
  // { label: "Total Other Income", key: "toa", width: "180px" },

  // { label: "Gross Total", key: "gt", width: "120px" },

  // { label: "Deduction u/s 80C", key: "80c", width: "150px" },
  // // { label: "Deduction u/s 80D", key: "80d", width: "150px" },

  // { label: "Any Other Deduction", key: "ad3", width: "180px" },
  // { label: "Any Other Deduction", key: "ad4", width: "180px" },
  // { label: "Any Other Deduction", key: "ad5", width: "180px" },
];

export const form26QFields = [
  { label: "Name", key: "na", width: "200px", className: "sticky-col col-3" },
  { label: "PAN", key: "pa", width: "150px", className: "sticky-col col-4" },
  { label: "Address", key: "ad", width: "300px" },
  { label: "PinCode", key: "pi", width: "120px" },
  {
    label: "Nature Of Payment",
    key: "np",
    width: "400px",
  },
  { label: "Amount Paid", key: "ap", width: "150px" },
  { label: "Date Of Amount Paid/Credit", key: "apd", width: "220px" },
  { label: "Rate Of TDS In %", key: "rt", width: "120px" },
  { label: "TDS Amount", key: "ta", width: "120px" },
  { label: "INTT", key: "it", width: "120px" },
  { label: "Total Tax", key: "tt", width: "120px" },
  { label: "Cheque No./ Cash", key: "cn", width: "150px" },
  { label: "Bank Name Where Tax Deposited", key: "tdbn", width: "250px" },
  // { label: "Bank BSR Code", key: "bc", width: "180px" },
  // { label: "Challan No.", key: "chno", width: "180px" },
  // { label: "Challan Date", key: "chdt", width: "180px" },
];

export const form27EQFields = [
  { label: "Name", key: "na", width: "200px", className: "sticky-col col-3" },
  { label: "PAN", key: "pa", width: "150px", className: "sticky-col col-4" },
  { label: "Address", key: "ad", width: "300px" },
  { label: "PinCode", key: "pi", width: "120px" },
  {
    label: "Nature Of Payment",
    key: "np",
    width: "350px",
  },
  { label: "Amount Paid", key: "ap", width: "150px" },
  { label: "Date Of Amount Paid/Credit", key: "apd", width: "220px" },
  { label: "Rate Of TDS In %", key: "rt", width: "120px" },
  { label: "TCS Amount", key: "ta", width: "120px" },
  { label: "INTT", key: "it", width: "120px" },
  { label: "Total Tax", key: "tt", width: "120px" },
  { label: "Cheque No./ Cash", key: "cn", width: "150px" },
  { label: "Bank Name Where Tax Deposited", key: "tdbn", width: "250px" },
  // { label: "Bank BSR Code", key: "bc", width: "180px" },
  // { label: "Challan No.", key: "chno", width: "180px" },
  // { label: "Challan Date", key: "chdt", width: "180px" },
];

export const formGSTR1Fields = [
  {
    label: "GSTIN of supplier",
    key: "sug",
    width: "220px",
    className: "sticky-col col-3",
  },
  { label: "Trade/Legal name", key: "tn", width: "180px" },
  { label: "Invoice number", key: "inv", width: "180px" },
  { label: "Invoice Date", key: "indt", width: "150px" },
  { label: "Rate(%)", key: "ra", width: "120px" },
  { label: "Taxable Value (₹) i.e Basic Amount", key: "tv", width: "250px" },
  { label: "Integrated Tax(₹)", key: "ig", width: "150px" },
  { label: "Central Tax(₹)", key: "cg", width: "150px" },
  { label: "State/UT Tax(₹)", key: "sg", width: "150px" },
  { label: "Invoice Value(₹) i.e Total Amount", key: "iv", width: "250px" },
  { label: "Cess(₹)", key: "ce", width: "150px" },
];

export const formGSTR7Fields = [
  {
    label: "Name Of Party",
    key: "pn",
    width: "220px",
    className: "sticky-col col-3",
  },
  { label: "Invoice Number", key: "in", width: "120px" },
  { label: "GSTN", key: "pg", width: "120px" },
  { label: "Invoice Taxable Value", key: "tv", width: "150px" },
  { label: "CGST 1%", key: "cg", width: "120px" },
  { label: "SGST 1%", key: "sg", width: "120px" },
  { label: "Total", key: "tl", width: "120px" },
];

export const genReport24Q_DeducteeHeader = [
  { label: "Challan Serial No.", key: "Challan Serial No." },
  { label: "Section Code", key: "Section Code", defaultValue: "92A" },
  {
    label: "Employee Reference No. Provided by Employer",
    key: "Employee Reference No. Provided by Employer",
    defaultValue: "",
  },
  { label: "PAN of the Employee", key: "pa", defaultValue: "" },
  { label: "PAN Ref. No.", key: "PAN Ref. No.", defaultValue: "" },
  { label: "Name of Employee", key: "en", defaultValue: "" },
  {
    label: "Date of Payment/Credited",
    key: "mn",
    defaultValue: "lastDtOfMon",
  },
  {
    label: "Taxable amount on which Tax Deducted",
    key: "gt",
    defaultValue: "",
  },
  { label: "TDS*", key: "it", defaultValue: "" },
  { label: "Surcharge", key: "Surcharge", defaultValue: "" },
  {
    label: "Health and Education Cess",
    key: "Health and Education Cess",
    defaultValue: "",
  },
  { label: "Total Tax Deposited", key: "it", defaultValue: "" },
  {
    label: "Date of Deduction",
    key: "mn",
    defaultValue: "lastDtOfMon",
  },
  {
    label: "Reason for Non-deduction / Lower Deduction, if any",
    key: "Reason for Non-deduction / Lower Deduction, if any",
    defaultValue: "",
  },
  { label: "Certificate number", key: "Certificate number", defaultValue: "" },
  {
    label: "Email Id of the Deductee",
    key: "Email Id of the Deductee",
    defaultValue: "",
  },
];

export const genReport24Q_ChallanHeader = [
  { label: "Challan Serial No.", key: "Challan Serial No." },
  { label: "Section Code", key: "Section Code" },
  { label: "Income Tax", key: "ca" },
  { label: "Surcharge", key: "Surcharge" },
  { label: "Health and Education Cess", key: "Health and Education Cess" },
  { label: "Interest", key: "in" },
  { label: "Late Fee u/s 234E", key: "lf" },
  { label: "Others", key: "Others" },
  { label: "Total Tax Deposited", key: "Total Tax Deposited" },
  { label: "Cheque/DD No.", key: "Cheque/DD No." },
  { label: "BSR Code", key: "bc" },
  { label: "Date on which Tax Deposited", key: "cd" },
  { label: "Bank Challan No./Transfer Voucher No.", key: "cn" },
  {
    label: "Whether deposited by book entry?Yes/No",
    key: "Whether deposited by book entry?Yes/No",
  },
  { label: "Minor Head of Challan", key: "Minor Head of Challan" },
  {
    label: "Interest (As per Deductee Annexure)",
    key: "Interest (As per Deductee Annexure)",
  },
  {
    label: "Others (As per Deductee Annexure)",
    key: "Others (As per Deductee Annexure)",
  },
];

export const genReport24Q_EmployerHeader = [
  { label: "TAN of Employer", key: "ta" },
  { label: "PAN of Employer", key: "pa" },
  { label: "Name of Employer", key: "na" },
  { label: "Branch/Division of the Employer", key: "ci" },
  { label: "Flat / Door / Block No.", key: "ai" },
  { label: "Name of premises / Building / Village", key: "a2" },
  { label: "Road / Street / Lane / Post Office", key: "Post Office" },
  { label: "Area / Locality / Taluka / Sub division", key: "ci" },
  { label: "Town / City / District", key: "ci" },
  { label: "State of the Employer", key: "st" },
  { label: "PIN of the Employer", key: "pi" },
  { label: "Email of the Employer", key: "ge" },
  { label: "STD Code of the Employer", key: "STD Code" },
  { label: "Telephone number of the Employer", key: "m1" },
  {
    label: "Change of Address of Employer since last Return",
    key: "Change of Addres",
  },
  {
    label: "Status of Employer (Fill Type of Employer also in Row 32)",
    key: "Status of Employer",
  },
  { label: "Name of the Person responsible for deduction", key: "dn" },
  {
    label: "Designation of the Person Responsible for Deduction",
    key: "Designation of the Person",
  },
  { label: "Flat / Door / Block No.", key: "Block No." },
  { label: "Name of premises / Building / Village", key: "Village" },
  { label: "Road / Street / Lane / Post Office", key: "Lane" },
  { label: "Area / Locality / Taluka / Sub division", key: "Taluka" },
  { label: "Town / City / District", key: "ci" },
  {
    label: "State of the Person responsible for deduction",
    key: "state of the Person",
  },
  {
    label: "PIN of the Person responsible for deduction",
    key: "PIN of the Person",
  },
  {
    label: "Email of the Person responsible for deduction",
    key: "Email of the Person",
  },
  {
    label: "Telephone number of the Person responsible for deduction",
    key: "am",
  },
  {
    label: "Change of Address of Responsible Person since last Return",
    key: "since last Return",
  },
  { label: "Type of Employer", key: "Type of Employer" },
  { label: "State of the Employer", key: "State of the Employer" },
  { label: "PAO Code", key: "PAO Code" },
  { label: "DDO Code", key: "DDO Code" },
  { label: "Ministry Name", key: "Ministry Name" },
  { label: "Ministry Name (If Others)", key: "Name (If Others)" },
  { label: "PAO Reg. No.", key: "PAO Reg. No." },
  { label: "DDO Reg. No.", key: "DDO Reg. No." },
  { label: "PAN of the Person Responsible for Deduction", key: "dp" },
];

// export const getReport24Q_SalaryDetailHeader = [
//   {
//     label: "Employee Reference No. Provided by Employer",
//     key: "Employee Reference No. Provided by Employer",
//   },
//   { label: "Employee PAN", key: "pa" },
//   { label: "Name of Employee", key: "en" },
//   { label: "Designation", key: "de" },
//   { label: "Sex", key: "Sex" },
//   { label: "Date of Birth", key: "Date of Birth" },
//   {
//     label: "Period of Employment From - Date",
//     key: "Period of Employment From - Date",
//   },
//   {
//     label: "Period of Employment To - Date",
//     key: "Period of Employment To - Date",
//   },
//   {
//     label: "115BAC Section Applicable (New Tax Regime)",
//     key: "115BAC Section Applicable (New Tax Regime)",
//   },
//   {
//     label: "Gross Salary as per provisions contained in sec.17(1)",
//     key: "gt",
//   },
//   {
//     label:
//       "Value of perquisites [section 17(2)] (as per FormNo.12BA, wherever applicable)",
//     key: "Value of perquisites [section 17(2)] (as per FormNo.12BA, wherever applicable)",
//   },
//   {
//     label:
//       "Profits in lieu of salary [section 17(3)] (as per Form No.12BA, wherever applicable)",
//     key: "Profits in lieu of salary [section 17(3)] (as per Form No.12BA, wherever applicable)",
//   },
//   {
//     label:
//       "Taxable Amount on which tax is deducted by the current employer (J + K+ L)",
//     key: "Taxable Amount on which tax is deducted by the current employer (J + K+ L)",
//   },
//   {
//     label:
//       "Reported Taxable Amount on which tax is deducted by previous employer(s)",
//     key: "Reported Taxable Amount on which tax is deducted by previous employer(s)",
//   },
//   { label: "Total Salary (M + N)", key: "Total Salary (M + N)" },
//   {
//     label: "Travel concession or assistance Section 10(5)",
//     key: "Travel concession or assistance Section 10(5)",
//   },
//   {
//     label: "Death-cum-retirement gratuity Section 10(10)",
//     key: "Death-cum-retirement gratuity Section 10(10)",
//   },
//   {
//     label: "Commuted value of pension Section 10(10A)",
//     key: "Commuted value of pension Section 10(10A)",
//   },
//   {
//     label: "Cash equivalent of leave salary encashment Section 10(10AA)",
//     key: "Cash equivalent of leave salary encashment Section 10(10AA)",
//   },
//   {
//     label: "House rent allowance Section 10(13A)",
//     key: "House rent allowance Section 10(13A)",
//   },
//   {
//     label: "Amount of exemption under section 10 Others",
//     key: "Amount of exemption under section 10 Others",
//   },
//   {
//     label:
//       "Total amount of exemption claimed under section 10 (Total of P to U)",
//     key: "Total amount of exemption claimed under section 10 (Total of P to U)",
//   },
//   {
//     label: "Standard Deduction under section 16 (ia) Manual Edit Flag",
//     key: "Standard Deduction under section 16 (ia) Manual Edit Flag",
//   },
//   {
//     label: "Standard Deduction under section 16 (ia) Amount",
//     key: "Standard Deduction under section 16 (ia) Amount",
//   },
//   {
//     label: "Deduction under section 16 (ii)",
//     key: "Deduction under section 16 (ii)",
//   },
//   {
//     label: "Deduction under section 16 (iii)",
//     key: "Deduction under section 16 (iii)",
//   },
//   {
//     label:
//       "Total Deduction under section 16(ia), 16(ii) and 16(iii) (X + Y + Z)",
//     key: "Total Deduction under section 16(ia), 16(ii) and 16(iii) (X + Y + Z)",
//   },
//   {
//     label: "Income chargeble under the head Salaries (O - V - AA)",
//     key: "Income chargeble under the head Salaries (O - V - AA)",
//   },
//   {
//     label:
//       "Income (or admissible loss) from house property reported by employee offered for TDS [section 192 (2B)]",
//     key: "Income (or admissible loss) from house property reported by employee offered for TDS [section 192 (2B)]",
//   },
//   {
//     label:
//       "Income under the head Other Sources offered for TDS [section 192 (2B)]",
//     key: "Income under the head Other Sources offered for TDS [section 192 (2B)]",
//   },
//   {
//     label: "Gross Total Income (AB + AC + AD)",
//     key: "Gross Total Income (AB + AC + AD)",
//   },
//   {
//     label: "Chapter-VIA Deductions Section 80C",
//     key: "d80c",
//   },
//   {
//     label: "Chapter-VIA Deductions Section 80CCC",
//     key: "Chapter-VIA Deductions Section 80CCC",
//   },
//   {
//     label: "Chapter-VIA Deductions Section 80CCD(1)",
//     key: "d80ccd",
//   },
//   {
//     label: "Chapter-VIA Deductions Section 80CCD(1B)",
//     key: "d80ccd1bc",
//   },
//   {
//     label: "Chapter-VIA Deductions Section 80CCD(2)",
//     key: "Chapter-VIA Deductions Section 80CCD(2)",
//   },
//   {
//     label: "Chapter-VIA Deductions Section 80CCG",
//     key: "Chapter-VIA Deductions Section 80CCG",
//   },
//   {
//     label: "Chapter-VIA Deductions Section 80D",
//     key: "d80d",
//   },
//   {
//     label: "Chapter-VIA Deductions Section 80E",
//     key: "Chapter-VIA Deductions Section 80E",
//   },
//   {
//     label: "Chapter-VIA Deductions Section 80G",
//     key: "d80g",
//   },
//   {
//     label: "Chapter-VIA Deductions Section 80TTA",
//     key: "Chapter-VIA Deductions Section 80TTA",
//   },
//   {
//     label: "Chapter-VIA Deductions Others",
//     key: "Chapter-VIA Deductions Others",
//   },
//   {
//     label: "Total Amount deductible under Chapter VI-A",
//     key: "td",
//   },
//   {
//     label: "Total Taxable Income (AE - BE)",
//     key: "Total Taxable Income (AE - BE)",
//   },
//   {
//     label:
//       "Income Tax on Total Income Manual Edit Flag Tax shown in Col.AV will be Imported if selected 'Yes'",
//     key: "Income Tax on Total Income Manual Edit Flag Tax shown in Col.AV will be Imported if selected 'Yes'",
//   },
//   {
//     label: "Income Tax on Total Income before Rebate u/s 87A Amount",
//     key: "it",
//   },
//   {
//     label: "Rebate u/s 87A Manual Edit Flag",
//     key: "Rebate u/s 87A Manual Edit Flag",
//   },
//   { label: "Rebate u/s 87A Amount", key: "Rebate u/s 87A Amount" },
//   {
//     label: "Income Tax on Total Income after Rebate u/s 87A (BH - BJ)",
//     key: "Income Tax on Total Income after Rebate u/s 87A (BH - BJ)",
//   },
//   { label: "Surcharge on (BK)", key: "Surcharge on (BK)" },
//   {
//     label: "Health and Education Cess on (BK + BL)",
//     key: "Health and Education Cess on (BK + BL)",
//   },
//   { label: "Tax Payable (BK + BL + BM)", key: "Tax Payable (BK + BL + BM)" },
//   {
//     label:
//       "Income Tax Relief Under Section 89 when salary etc. is paid in arrear or in advance",
//     key: "Income Tax Relief Under Section 89 when salary etc. is paid in arrear or in advance",
//   },
//   { label: "Net Tax Payable (BN-BO)", key: "Net Tax Payable (BN-BO)" },
//   {
//     label:
//       "Total Amount of tax deducted at source by the current employer for the whole year",
//     key: "Total Amount of tax deducted at source by the current employer for the whole year",
//   },
//   {
//     label: "Reported amount of Tax deducted at source by previous employer(s)",
//     key: "Reported amount of Tax deducted at source by previous employer(s)",
//   },
//   { label: "Total TDS (BQ + BR + CB)", key: "Total TDS (BQ + BR + CB)" },
//   {
//     label: "Shortfall in tax deduction(+) / Excess tax deduction(-) (BP - BS)",
//     key: "Shortfall in tax deduction(+) / Excess tax deduction(-) (BP - BS)",
//   },
//   {
//     label:
//       "Whether tax deducted at Higher rate due to non furnishing of PAN by deductee",
//     key: "Whether tax deducted at Higher rate due to non furnishing of PAN by deductee",
//   },
//   {
//     label:
//       "Whether contributions paid by the trustees of an approved superannuation fund",
//     key: "Whether contributions paid by the trustees of an approved superannuation fund",
//   },
//   {
//     label: "Name of the superannuation fund",
//     key: "Name of the superannuation fund",
//   },
//   {
//     label:
//       "Date from which the employee has contributed to the superannuation fund",
//     key: "Date from which the employee has contributed to the superannuation fund",
//   },
//   {
//     label:
//       "Date to which the employee has contributed to the superannuation fund",
//     key: "Date to which the employee has contributed to the superannuation fund",
//   },
//   {
//     label:
//       "The amount of contribution repaid on account of principal and interest from superannuation fund",
//     key: "The amount of contribution repaid on account of principal and interest from superannuation fund",
//   },
//   {
//     label:
//       "The average rate of deduction of tax during the preceding three years",
//     key: "The average rate of deduction of tax during the preceding three years",
//   },
//   {
//     label: "The amount of tax deducted on repayment of superannuation fund",
//     key: "The amount of tax deducted on repayment of superannuation fund",
//   },
//   {
//     label:
//       "(HRA) Whether aggregate rent payment exceeds rupees one lakh during previous year",
//     key: "(HRA) Whether aggregate rent payment exceeds rupees one lakh during previous year",
//   },
//   {
//     label:
//       "In case of aggregate rent payment exceeds rupees one lakh during previous year Name of landlord 1",
//     key: "In case of aggregate rent payment exceeds rupees one lakh during previous year Name of landlord 1",
//   },
//   {
//     label:
//       "In case of aggregate rent payment exceeds rupees one lakh during previous year PAN of landlord 1",
//     key: "In case of aggregate rent payment exceeds rupees one lakh during previous year PAN of landlord 1",
//   },
//   {
//     label:
//       "In case of aggregate rent payment exceeds rupees one lakh during previous year Name of landlord 2",
//     key: "In case of aggregate rent payment exceeds rupees one lakh during previous year Name of landlord 2",
//   },
//   {
//     label:
//       "In case of aggregate rent payment exceeds rupees one lakh during previous year PAN of landlord 2",
//     key: "In case of aggregate rent payment exceeds rupees one lakh during previous year PAN of landlord 2",
//   },
//   {
//     label:
//       "In case of aggregate rent payment exceeds rupees one lakh during previous year Name of landlord 3",
//     key: "In case of aggregate rent payment exceeds rupees one lakh during previous year Name of landlord 3",
//   },
//   {
//     label:
//       "In case of aggregate rent payment exceeds rupees one lakh during previous year PAN of landlord 3",
//     key: "In case of aggregate rent payment exceeds rupees one lakh during previous year PAN of landlord 3",
//   },
//   {
//     label:
//       "In case of aggregate rent payment exceeds rupees one lakh during previous year Name of landlord 4",
//     key: "In case of aggregate rent payment exceeds rupees one lakh during previous year Name of landlord 4",
//   },
//   {
//     label:
//       "In case of aggregate rent payment exceeds rupees one lakh during previous year PAN of landlord 4",
//     key: "In case of aggregate rent payment exceeds rupees one lakh during previous year PAN of landlord 4",
//   },
//   {
//     label:
//       "Whether Interest paid  to the lender under the head 'Income from house property'",
//     key: "Whether Interest paid  to the lender under the head 'Income from house property'",
//   },
//   {
//     label:
//       "In case of deduction of interest under the head income from house property Name of lender 1",
//     key: "In case of deduction of interest under the head income from house property Name of lender 1",
//   },
//   {
//     label:
//       "In case of deduction of interest under the head income from house property PAN of lender 1",
//     key: "In case of deduction of interest under the head income from house property PAN of lender 1",
//   },
//   {
//     label:
//       "In case of deduction of interest under the head income from house property Name of lender 2",
//     key: "In case of deduction of interest under the head income from house property Name of lender 2",
//   },
//   {
//     label:
//       "In case of deduction of interest under the head income from house property PAN of lender 2",
//     key: "In case of deduction of interest under the head income from house property PAN of lender 2",
//   },
//   {
//     label:
//       "In case of deduction of interest under the head income from house property Name of lender 3",
//     key: "In case of deduction of interest under the head income from house property Name of lender 3",
//   },
//   {
//     label:
//       "In case of deduction of interest under the head income from house property PAN of lender 3",
//     key: "In case of deduction of interest under the head income from house property PAN of lender 3",
//   },
//   {
//     label:
//       "In case of deduction of interest under the head income from house property Name of lender 4",
//     key: "In case of deduction of interest under the head income from house property Name of lender 4",
//   },
//   {
//     label:
//       "In case of deduction of interest under the head income from house property PAN of lender 4",
//     key: "In case of deduction of interest under the head income from house property PAN of lender 4",
//   },
//   { label: "Whether Pensioner", key: "Whether Pensioner" },
// ];
export const getReport24Q_SalaryDetailHeader = [
  {
    label: "Employee Reference No. Provided by Employer",
    key: "Employee Reference No. Provided by Employer",
  },
  { label: "Employee PAN", key: "pa" },
  { label: "Name of Employee", key: "en" },
  { label: "Designation", key: "de" },
  { label: "Sex", key: "Sex" },
  { label: "Date of Birth", key: "Date of Birth" },
  {
    label: "Period of Employment From - Date",
    key: "Period of Employment From - Date",
  },
  {
    label: "Period of Employment To - Date",
    key: "Period of Employment To - Date",
  },
  {
    label: "115BAC Section Applicable (New Tax Regime)",
    key: "nt",
  },
  { label: "Gross Salary as per provisions contained in sec.17(1)", key: "gt" },

  // Perquisites
  {
    label:
      "Value of perquisites [section 17(2)]\n(as per FormNo.12BA, wherever applicable)",
    key: "Value of perquisites [section 17(2)]\n(as per FormNo.12BA, wherever applicable)",
  },

  // Profits in lieu of salary
  {
    label:
      "Profits in lieu of salary [section 17(3)]\n(as per Form No.12BA, wherever applicable) ",
    key: "Profits in lieu of salary [section 17(3)]\n(as per Form No.12BA, wherever applicable) ",
  },

  {
    label:
      "Taxable Amount on which tax is deducted by the current employer\n\n(J + K+ L)",
    key: "Taxable Amount on which tax is deducted by the current employer (J + K+ L)",
  },

  {
    label:
      "Reported Taxable Amount on which tax is deducted by previous employer(s)",
    key: "Reported Taxable Amount on which tax is deducted by previous employer(s)",
  },

  { label: "Total Salary\n\n(M + N)", key: "Total Salary (M + N)" },

  {
    label: "Travel concession or assistance\n\nSection 10(5)",
    key: "Travel concession or assistance Section 10(5)",
  },
  {
    label: "Death-cum-retirement gratuity\n\nSection 10(10)",
    key: "Death-cum-retirement gratuity Section 10(10)",
  },
  {
    label: "Commuted value of pension\n\nSection 10(10A)",
    key: "Commuted value of pension Section 10(10A)",
  },
  {
    label: "Cash equivalent of leave salary encashment\n\nSection 10(10AA)",
    key: "Cash equivalent of leave salary encashment Section 10(10AA)",
  },
  {
    label: "House rent allowance\n\nSection 10(13A)",
    key: "House rent allowance Section 10(13A)",
  },

  // Missing (added)
  {
    label: "Other special allowances under section 10(14)",
    key: "Other special allowances under section 10(14)",
  },

  {
    label: "Amount of exemption under section 10\n\nOthers",
    key: "Amount of exemption under section 10 Others",
  },

  {
    label:
      "Total amount of exemption claimed under section 10\n\n(Total of P to V)",
    key: "Total amount of exemption claimed under section 10 (Total of P to U)",
  },

  {
    label: "Standard Deduction under section 16 (ia)\n\nManual Edit Flag",
    key: "Standard Deduction under section 16 (ia) Manual Edit Flag",
  },
  {
    label: "Standard Deduction under section 16 (ia)\n\nAmount",
    key: "Standard Deduction under section 16 (ia) Amount",
  },

  {
    label: "Deduction under section 16 (ii)",
    key: "Deduction under section 16 (ii)",
  },
  {
    label: "Deduction under section 16 (iii)",
    key: "Deduction under section 16 (iii)",
  },

  {
    label:
      "Total Deduction under section 16(ia), 16(ii) and 16(iii)\n\n(Y + Z + AA)",
    key: "Total Deduction under section 16(ia), 16(ii) and 16(iii) (X + Y + Z)",
  },

  {
    label: "Income chargeble under the head Salaries\n\n(O - W - AB)",
    key: "Income chargeble under the head Salaries (O - V - AA)",
  },

  {
    label:
      "Income (or admissible loss) from house property reported by\nemployee offered for TDS\n[section 192 (2B)]",
    key: "Income (or admissible loss) from house property reported by employee offered for TDS [section 192 (2B)]",
  },

  {
    label:
      "Income under the head Other Sources offered for TDS\n[section 192 (2B)]",
    key: "Income under the head Other Sources offered for TDS [section 192 (2B)]",
  },

  {
    label: "Gross Total Income\n\n(AC + AD + AE)",
    key: "Gross Total Income (AB + AC + AD)",
  },

  { label: "Chapter-VIA Deductions\n\nSection 80C", key: "d80c" },
  {
    label: "Chapter-VIA Deductions\n\nSection 80CCC",
    key: "Chapter-VIA Deductions Section 80CCC",
  },
  { label: "Chapter-VIA Deductions\n\nSection 80CCD(1)", key: "d80ccd" },
  { label: "Chapter-VIA Deductions\n\nSection 80CCD(1B)", key: "d80ccd1bc" },
  {
    label: "Chapter-VIA Deductions\n\nSection 80CCD(2)",
    key: "Chapter-VIA Deductions Section 80CCD(2)",
  },
  {
    label: "Chapter-VIA Deductions\n\nSection 80CCG",
    key: "Chapter-VIA Deductions Section 80CCG",
  },

  // Missing (added)
  {
    label: "Chapter-VIA Deductions\n\nSection 80CCH",
    key: "Chapter-VIA Deductions Section 80CCH",
  },
  {
    label: "Chapter-VIA Deductions\n\nSection 80CCH(1)",
    key: "Chapter-VIA Deductions Section 80CCH(1)",
  },

  { label: "Chapter-VIA Deductions\n\nSection 80D", key: "d80d" },
  {
    label: "Chapter-VIA Deductions\n\nSection 80E",
    key: "Chapter-VIA Deductions Section 80E",
  },
  { label: "Chapter-VIA Deductions\n\nSection 80G", key: "d80g" },
  {
    label: "Chapter-VIA Deductions\n\nSection 80TTA",
    key: "Chapter-VIA Deductions Section 80TTA",
  },
  {
    label: "Chapter-VIA Deductions\n\nOthers",
    key: "Chapter-VIA Deductions Others",
  },

  { label: "Total Amount deductible under Chapter VI-A", key: "td" },

  {
    label: "Total Taxable Income\n\n(AF - BJ)",
    key: "Total Taxable Income (AE - BE)",
  },

  {
    label:
      "Income Tax on Total Income\n\nManual Edit Flag\n\nTax shown in Col. BM will be Imported if selected 'Yes'",
    key: "Income Tax on Total Income Manual Edit Flag Tax shown in Col.AV will be Imported if selected 'Yes'",
  },

  {
    label: "Income Tax on Total Income before Rebate u/s 87A\n\nAmount",
    key: "it",
  },

  {
    label: "Rebate u/s 87A\n\nManual Edit Flag",
    key: "Rebate u/s 87A Manual Edit Flag",
  },
  { label: "Rebate u/s 87A\n\nAmount", key: "Rebate u/s 87A Amount" },

  {
    label: "Income Tax on Total Income after Rebate u/s 87A\n\n(BM - BO)",
    key: "Income Tax on Total Income after Rebate u/s 87A (BH - BJ)",
  },

  { label: "Surcharge on (BP)", key: "Surcharge on (BK)" },
  {
    label: "Health and Education Cess on (BP + BQ)",
    key: "Health and Education Cess on (BK + BL)",
  },
  { label: "Tax Payable\n\n(BP + BQ + BR)", key: "Tax Payable (BK + BL + BM)" },

  {
    label:
      "Income Tax Relief Under Section 89 when salary etc. is paid in arrear or in advance",
    key: "Income Tax Relief Under Section 89 when salary etc. is paid in arrear or in advance",
  },

  { label: "Net Tax Payable\n\n(BS-BT)", key: "Net Tax Payable (BN-BO)" },

  {
    label:
      "Total Amount of tax deducted at source by the current employer for the whole year",
    key: "Total Amount of tax deducted at source by the current employer for the whole year",
  },

  {
    label: "Reported amount of Tax deducted at source by previous employer(s)",
    key: "Reported amount of Tax deducted at source by previous employer(s)",
  },

  {
    label: "Total TDS\n\n(BV + BW + CG + DA)",
    key: "Total TDS (BQ + BR + CB)",
  },

  {
    label:
      "Shortfall in tax deduction(+) / Excess tax deduction(-)\n\n(BU - BX)",
    key: "Shortfall in tax deduction(+) / Excess tax deduction(-) (BP - BS)",
  },

  {
    label:
      "Whether tax deducted at Higher rate due to non furnishing of PAN by deductee",
    key: "Whether tax deducted at Higher rate due to non furnishing of PAN by deductee",
  },

  {
    label:
      "Whether contributions paid by the trustees of an approved superannuation fund",
    key: "Whether contributions paid by the trustees of an approved superannuation fund",
  },

  {
    label: "Name of the superannuation fund",
    key: "Name of the superannuation fund",
  },
  {
    label:
      "Date from which the employee has contributed to the superannuation fund",
    key: "Date from which the employee has contributed to the superannuation fund",
  },

  {
    label:
      "Date to which the employee has contributed to the superannuation fund",
    key: "Date to which the employee has contributed to the superannuation fund",
  },

  {
    label:
      "The amount of contribution repaid on account of principal and interest from superannuation fund",
    key: "The amount of contribution repaid on account of principal and interest from superannuation fund",
  },

  {
    label:
      "The average rate of deduction of tax during the preceding three years",
    key: "The average rate of deduction of tax during the preceding three years",
  },

  {
    label: "The amount of tax deducted on repayment of superannuation fund",
    key: "The amount of tax deducted on repayment of superannuation fund",
  },

  {
    label:
      "(HRA)\nWhether aggregate rent payment exceeds rupees one lakh during previous year",
    key: "(HRA) Whether aggregate rent payment exceeds rupees one lakh during previous year",
  },

  {
    label:
      "In case of aggregate rent payment exceeds rupees one lakh during previous year\n\nName of landlord 1",
    key: "In case of aggregate rent payment exceeds rupees one lakh during previous year Name of landlord 1",
  },
  {
    label:
      "In case of aggregate rent payment exceeds rupees one lakh during previous year\n\nPAN of landlord 1",
    key: "In case of aggregate rent payment exceeds rupees one lakh during previous year PAN of landlord 1",
  },
  {
    label:
      "In case of aggregate rent payment exceeds rupees one lakh during previous year\n\nName of landlord 2",
    key: "In case of aggregate rent payment exceeds rupees one lakh during previous year Name of landlord 2",
  },
  {
    label:
      "In case of aggregate rent payment exceeds rupees one lakh during previous year\n\nPAN of landlord 2",
    key: "In case of aggregate rent payment exceeds rupees one lakh during previous year PAN of landlord 2",
  },

  {
    label:
      "In case of aggregate rent payment exceeds rupees one lakh during previous year\n\nName of landlord 3",
    key: "In case of aggregate rent payment exceeds rupees one lakh during previous year Name of landlord 3",
  },

  {
    label:
      "In case of aggregate rent payment exceeds rupees one lakh during previous year\n\nPAN of landlord 3",
    key: "In case of aggregate rent payment exceeds rupees one lakh during previous year PAN of landlord 3",
  },

  {
    label:
      "In case of aggregate rent payment exceeds rupees one lakh during previous year\n\nName of landlord 4",
    key: "In case of aggregate rent payment exceeds rupees one lakh during previous year Name of landlord 4",
  },

  {
    label:
      "In case of aggregate rent payment exceeds rupees one lakh during previous year\n\nPAN of landlord 4",
    key: "In case of aggregate rent payment exceeds rupees one lakh during previous year PAN of landlord 4",
  },

  {
    label:
      "Whether Interest paid  to the lender under the head 'Income from house property'",
    key: "Whether Interest paid  to the lender under the head 'Income from house property'",
  },

  {
    label:
      "In case of deduction of interest under the head income from house property\n\nName of lender 1",
    key: "In case of deduction of interest under the head income from house property Name of lender 1",
  },

  {
    label:
      "In case of deduction of interest under the head income from house property\n\nPAN of lender 1",
    key: "In case of deduction of interest under the head income from house property PAN of lender 1",
  },

  {
    label:
      "In case of deduction of interest under the head income from house property\n\nName of lender 2",
    key: "In case of deduction of interest under the head income from house property Name of lender 2",
  },

  {
    label:
      "In case of deduction of interest under the head income from house property\n\nPAN of lender 2",
    key: "In case of deduction of interest under the head income from house property PAN of lender 2",
  },

  {
    label:
      "In case of deduction of interest under the head income from house property\n\nName of lender 3",
    key: "In case of deduction of interest under the head income from house property Name of lender 3",
  },

  {
    label:
      "In case of deduction of interest under the head income from house property\n\nPAN of lender 3",
    key: "In case of deduction of interest under the head income from house property PAN of lender 3",
  },

  {
    label:
      "In case of deduction of interest under the head income from house property\n\nName of lender 4",
    key: "In case of deduction of interest under the head income from house property Name of lender 4",
  },

  {
    label:
      "In case of deduction of interest under the head income from house property\n\nPAN of lender 4",
    key: "In case of deduction of interest under the head income from house property PAN of lender 4",
  },

  { label: "Whether Pensioner", key: "Whether Pensioner" },

  // Last missing field added as per your instruction
  {
    label: "Amount reported as per section 192(2B),",
    key: "Amount reported as per section 192(2B),",
  },
  {
    label: "gender",
    key: "eg",
  },
];

export const genReport26Q_DeductorHeader = [
  { label: "TAN of Deductor", key: "ta" },
  { label: "PAN of Deductor", key: "pa" },
  { label: "Name of Deductor", key: "na" },
  { label: "Branch/Division of the Deductor", key: "ci" },
  { label: "Flat / Door / Block No.", key: "ai" },
  { label: "Name of premises / Building / Village", key: "a2" },
  { label: "Road / Street / Lane / Post Office", key: "Post Office" },
  { label: "Area / Locality / Taluka / Sub division", key: "ci" },
  { label: "Town / City / District", key: "ci" },
  { label: "State of the Deductor", key: "st" },
  { label: "PIN of the Deductor", key: "pi" },
  { label: "Email of the Deductor", key: "ge" },
  { label: "STD Code of the Deductor", key: "STD Code" },
  { label: "Telephone number of the Deductor", key: "m1" },
  {
    label: "Change of Address of Deductor since last Return",
    key: "Change of Addres",
  },
  {
    label: "Status of Deductor (Fill Type of Deductor also in Row 32)",
    key: "Status of Deductor",
  },
  { label: "Name of the Person responsible for deduction", key: "dn" },
  {
    label: "Designation of the Person Responsible for Deduction",
    key: "Designation of the Person",
  },
  { label: "Flat / Door / Block No.", key: "Block No." },
  { label: "Name of premises / Building / Village", key: "Village" },
  { label: "Road / Street / Lane / Post Office", key: "Lane" },
  { label: "Area / Locality / Taluka / Sub division", key: "Taluka" },
  { label: "Town / City / District", key: "ci" },
  {
    label: "State of the Person responsible for deduction",
    key: "state of the Person",
  },
  {
    label: "PIN of the Person responsible for deduction",
    key: "PIN of the Person",
  },
  {
    label: "Email of the Person responsible for deduction",
    key: "Email of the Person",
  },
  {
    label: "Telephone number of the Person responsible for deduction",
    key: "am",
  },
  {
    label: "Change of Address of Responsible Person since last Return",
    key: "since last Return",
  },
  { label: "Type of Deductor", key: "Type of Deductor" },
  { label: "State of the Deductor", key: "State of the Deductor" },
  { label: "PAO Code", key: "PAO Code" },
  { label: "DDO Code", key: "DDO Code" },
  { label: "Ministry Name", key: "Ministry Name" },
  { label: "Ministry Name (If Others)", key: "Name (If Others)" },
  { label: "PAO Reg. No.", key: "PAO Reg. No." },
  { label: "DDO Reg. No.", key: "DDO Reg. No." },
  { label: "PAN of the Person Responsible for Deduction", key: "dp" },
];

export const genReport26Q_ChallanHeader = [
  { label: "Challan Serial No.", key: "Challan Serial No." },
  { label: "Section Code", key: "Section Code" },
  { label: "Income Tax", key: "ca" },
  { label: "Surcharge", key: "Surcharge" },
  { label: "Health and Education Cess", key: "Health and Education Cess" },
  { label: "Interest", key: "in" },
  { label: "Late Fee u/s 234E", key: "lf" },
  { label: "Others", key: "Others" },
  { label: "Total Tax Deposited", key: "Total Tax Deposited" },
  { label: "Cheque/DD No.", key: "Cheque/DD No." },
  { label: "BSR Code", key: "bc" },
  { label: "Date on which Tax Deposited", key: "cd" },
  { label: "Bank Challan No./Transfer Voucher No.", key: "cn" },
  {
    label: "Whether deposited by book entry?Yes/No",
    key: "Whether deposited by book entry?Yes/No",
  },
  { label: "Minor Head of Challan", key: "Minor Head of Challan" },
  {
    label: "Interest (As per Deductee Annexure)",
    key: "Interest (As per Deductee Annexure)",
  },
  {
    label: "Others (As per Deductee Annexure)",
    key: "Others (As per Deductee Annexure)",
  },
];

export const genReport26Q_DeducteeHeader = [
  { label: "Challan Serial No.", key: "Challan Serial No." },
  { label: "Section Code", key: "Section Code" },
  { label: "Deductee Code", key: "Deductee Code" },
  {
    label: "Permanent Account Number (PAN) of deductee",
    key: "pa",
  },
  {
    label: "Deductee Ref. No. / PAN Ref. No.",
    key: "Deductee Ref. No. / PAN Ref. No.",
  },
  { label: "Name of Deductee", key: "na" },
  { label: "Deductee Address1", key: "ad" },
  { label: "Deductee Address2", key: "Deductee Address2" },
  { label: "Deductee Address3", key: "Deductee Address3" },
  { label: "Deductee Address4", key: "Deductee Address4" },
  { label: "Deductee Address5", key: "Deductee Address5" },
  { label: "Deductee State", key: "Deductee State" },
  { label: "Deductee PIN", key: "pi" },
  { label: "Amount of Payment", key: "ap" },
  {
    label: "Date on which Amount paid / credited",
    key: "apd",
  },
  { label: "Rate at which Tax deducted", key: "rt" },
  { label: "Surcharge Rate", key: "Surcharge Rate" },
  {
    label: "Health and Education Cess Rate",
    key: "Health and Education Cess Rate",
  },
  { label: "Amount of Tax deducted", key: "ta" },
  { label: "Surcharge Amount", key: "Surcharge Amount" },
  {
    label: "Health and Education Cess Amount",
    key: "Health and Education Cess Amount",
  },
  { label: "Total Tax Deposited", key: "tt" },
  { label: "Date on which tax deducted", key: "mn" },
  {
    label:
      "Reason for Non-deduction/Lower Deduction/Deduction at Higher Rate, if any",
    key: "Reason for Non-deduction/Lower Deduction/Deduction at Higher Rate, if any",
  },
  { label: "Certificate number", key: "Certificate number" },
  {
    label:
      "Amount of cash withdrawal in excess of (a) Rs. 1 Crore (Section 194N) OR (b) Rs. 3 Crore (Section 194NC)",
    key: "Amount of cash withdrawal in excess of (a) Rs. 1 Crore (Section 194N) OR (b) Rs. 3 Crore (Section 194NC)",
  },
  {
    label:
      "Amount of cash withdrawal in excess of Rs. 20 Lakhs but not excess of (a) Rs. 1 Crore (Section 194NF) OR (b) Rs. 3 Crore (Section 194N-FT)",
    key: "Amount of cash withdrawal in excess of Rs. 20 Lakhs but not excess of (a) Rs. 1 Crore (Section 194NF) OR (b) Rs. 3 Crore (Section 194N-FT)",
  },
  {
    label:
      "Amount of cash withdrawal which is in excess of (a) Rs. 1 Crore (Section 194NF) OR (b) Rs. 3 Crore (Section 194N-FT)",
    key: "Amount of cash withdrawal which is in excess of (a) Rs. 1 Crore (Section 194NF) OR (b) Rs. 3 Crore (Section 194N-FT)",
  },
  { label: "Email Id of the Deductee", key: "Email Id of the Deductee" },
];

export const genReport27Q_CollectorHeader = [
  { label: "TAN of Collector", key: "ta" },
  { label: "PAN of Collector", key: "pa" },
  { label: "Name of Collector", key: "na" },
  { label: "Branch/Division of the Collector", key: "ci" },
  { label: "Flat / Door / Block No.", key: "ai" },
  { label: "Name of premises / Building / Village", key: "a2" },
  { label: "Road / Street / Lane / Post Office", key: "Post Office" },
  { label: "Area / Locality / Taluka / Sub division", key: "ci" },
  { label: "Town / City / District", key: "ci" },
  { label: "State of the Collector", key: "st" },
  { label: "PIN of the Collector", key: "pi" },
  { label: "Email of the Collector", key: "ge" },
  { label: "STD Code of the Collector", key: "STD Code" },
  { label: "Telephone number of the Collector", key: "m1" },
  {
    label: "Change of Address of Collector since last Return",
    key: "Change of Addres",
  },
  {
    label: "Status of Collector (Fill Type of Collector also in Row 32)",
    key: "Status of Collector",
  },
  { label: "Name of the Person responsible for Collection", key: "dn" },
  {
    label: "Designation of the Person Responsible for Collection",
    key: "Designation of the Person",
  },
  { label: "Flat / Door / Block No.", key: "Block No." },
  { label: "Name of premises / Building / Village", key: "Village" },
  { label: "Road / Street / Lane / Post Office", key: "Lane" },
  { label: "Area / Locality / Taluka / Sub division", key: "Taluka" },
  { label: "Town / City / District", key: "ci" },
  {
    label: "State of the Person responsible for Collection",
    key: "state of the Person",
  },
  {
    label: "PIN of the Person responsible for Collection",
    key: "PIN of the Person",
  },
  {
    label: "Email of the Person responsible for Collection",
    key: "Email of the Person",
  },
  {
    label: "Telephone number of the Person responsible for Collection",
    key: "am",
  },
  {
    label: "Change of Address of Responsible Person since last Return",
    key: "since last Return",
  },
  { label: "Type of Collector", key: "Type of Collector" },
  { label: "State of the Collector", key: "State of the Collector" },
  { label: "PAO Code", key: "PAO Code" },
  { label: "DDO Code", key: "DDO Code" },
  { label: "Ministry Name", key: "Ministry Name" },
  { label: "Ministry Name (If Others)", key: "Name (If Others)" },
  { label: "PAO Reg. No.", key: "PAO Reg. No." },
  { label: "DDO Reg. No.", key: "DDO Reg. No." },
  { label: "PAN of the Person Responsible for Collection", key: "dp" },
];

export const genReport27Q_ChallanHeader = [
  { label: "Challan Serial No.", key: "Challan Serial No." },
  { label: "Section Code", key: "Section Code" },
  { label: "Income Tax", key: "ca" },
  { label: "Surcharge", key: "Surcharge" },
  { label: "Health and Education Cess", key: "Health and Education Cess" },
  { label: "Interest", key: "in" },
  { label: "Late Fee u/s 234E", key: "lf" },
  { label: "Others", key: "Others" },
  { label: "Total Tax Deposited", key: "Total Tax Deposited" },
  { label: "Cheque/DD No.", key: "Cheque/DD No." },
  { label: "BSR Code", key: "bc" },
  { label: "Date on which Tax Deposited", key: "cd" },
  { label: "Bank Challan No./Transfer Voucher No.", key: "cn" },
  {
    label: "Whether deposited by book entry?Yes/No",
    key: "Whether deposited by book entry?Yes/No",
  },
  { label: "Minor Head of Challan", key: "Minor Head of Challan" },
  {
    label: "Interest (As per Deductee Annexure)",
    key: "Interest (As per Deductee Annexure)",
  },
  {
    label: "Others (As per Deductee Annexure)",
    key: "Others (As per Deductee Annexure)",
  },
];

export const genReport27Q_PartyHeader = [
  { label: "Challan Serial No.", key: "Challan Serial No." },
  { label: "Collection Code", key: "Collection Code" },
  { label: "Party Code", key: "Party Code" },
  {
    label: "Permanent Account Number (PAN) of Party",
    key: "pa",
  },
  { label: "PAN Ref. No.", key: "PAN Ref. No." },
  { label: "Name of Party", key: "na" },
  { label: "Party Address1", key: "ad" },
  { label: "Party Address2", key: "Party Address2" },
  { label: "Party Address3", key: "Party Address3" },
  { label: "Party Address4", key: "Party Address4" },
  { label: "Party Address5", key: "Party Address5" },
  { label: "Party State", key: "Party State" },
  { label: "Party PIN", key: "pi" },
  { label: "Total Value of Purchases", key: "Total Value of Purchases" },
  { label: "Amount Paid", key: "ap" },
  {
    label: "Date on which Amount Paid/debited",
    key: "apd",
  },
  { label: "Rate at which Tax collected", key: "Rate at which Tax collected" },
  { label: "Surcharge Rate", key: "Surcharge Rate" },
  {
    label: "Health and Education Cess Rate",
    key: "Health and Education Cess Rate",
  },
  { label: "Amount of Tax collected", key: "ta" },
  { label: "Surcharge Amount", key: "Surcharge Amount" },
  {
    label: "Health and Education Cess Amount",
    key: "Health and Education Cess Amount",
  },
  { label: "Total Tax Deposited", key: "tt" },
  { label: "Date on which tax collected", key: "mn" },
  {
    label: "Reason for Lower collection, if any",
    key: "Reason for Lower collection, if any",
  },
  { label: "Certificate number", key: "Certificate number" },
  { label: "Deductee is Non-Resident", key: "Deductee is Non-Resident" },
  {
    label: "Deductee is having Permanent Establishment in India",
    key: "Deductee is having Permanent Establishment in India",
  },
  {
    label:
      "Whether the payment by collectee is liable to TDS and TDS has been deducted from such payment",
    key: "Whether the payment by collectee is liable to TDS and TDS has been deducted from such payment",
  },
  { label: "Challan No.", key: "Challan No." },
  {
    label: "Date of payment of TDS to Central Government",
    key: "Date of payment of TDS to Central Government",
  },
  { label: "Email Id of the Party", key: "Email Id of the Party" },
  {
    label:
      "Whether deductee opting out of taxation regime u/s 115BAC (1A)? (Y/N)",
    key: "Whether deductee opting out of taxation regime u/s 115BAC (1A)? (Y/N)",
  },
];

export const getClientsEmployeeData = [
  { label: "Sr.No", key: "Sr.No" },
  { label: "NAME OF EMPLOYEE", key: "en" },
  { label: "PAN", key: "pa" },
  { label: "GROSS SALARY", key: "gt1" },
  { label: "TAX", key: "it1" },
  {
    label: "BOOK IDENTIFICATION NUMBER (BIN)",
    key: "BOOK IDENTIFICATION NUMBER (BIN)1",
  },
  { label: "GROSS SALARY", key: "gt2" },
  { label: "TAX", key: "it2" },
  {
    label: "BOOK IDENTIFICATION NUMBER (BIN)",
    key: "BOOK IDENTIFICATION NUMBER (BIN)2",
  },
  { label: "GROSS SALARY", key: "gt3" },
  { label: "TAX", key: "it3" },
  {
    label: "BOOK IDENTIFICATION NUMBER (BIN)",
    key: "BOOK IDENTIFICATION NUMBER (BIN)3",
  },
];
export const getReport24Q_DeducteeDetailHeader = [
  { label: "Month", key: "mn" },
  { label: "Basic", key: "ba" },
  { label: "D.A.", key: "da" },
  { label: "Grade Pay", key: "gp" },
  { label: "H.R.A.", key: "hr" },
  { label: "C.C.A.", key: "ca" },
  { label: "Other Salary", key: "os" },
  // { label: "TOTAL OTHER INCOME", key: "toi" },
  // { label: "TOTAL OTHER ALLOWANCE", key: "toa" },
  { label: "Employer's Contribution towards NPS", key: "nps" },
  { label: "Gross Total", key: "gt" },
  { label: "G.P.F.", key: "gpf" },
  { label: "G.P.F. Advance Deduction", key: "gpfad", width: "120px" },
  { label: "G.I.S.", key: "gis" },
  { label: "HRA Deduction", key: "hrad", width: "120px" },
  { label: "Vehical Deduction", key: "vcld", width: "120px" },
  // { label: "ANY OTHER DEDUCTION U/S 80C", key: "80c" },
  { label: "Income Tax", key: "it" },
  { label: "Total Deduction", key: "td" },
  { label: "Net Amount", key: "na" },
  { label: "Voucher Amount", key: "va", width: "150px" },
  { label: "Voucher Number", key: "vn", width: "150px" },
  { label: "Date", key: "ddd", width: "150px" },
  { label: "dc", key: "dc" },
  { label: "ar", key: "ar" },
  { label: "bo", key: "bo" },
];
export const reportIncometaxMemoHeader = [
  { label: "S.NO.", key: "S.NO." },
  { label: "PARTICULARS", key: "PARTICULARS" },
  { label: "", key: "" },
  { label: "AMOUNT", key: "AMOUNT" },
  { label: "AMOUNT", key: "AMOUNT" },
];
export const reportIncometaxMemo = [
  {
    sno: "1 a",
    label: "Basic Pay",
    //subLabel: "",
    key: "ba",
    bold: "true",
    formula: "",
    amtFormula: "",
    align: "center",
  },
  {
    sno: "b",
    label: "Grade Pay",
    //subLabel: "",
    key: "gp",
    bold: "false",
    formula: "",
    amtFormula: "",
    align: "left",
  },
  {
    sno: "c",
    label: "D. Allowance",
    //subLabel: "",
    key: "da",
    bold: "false",
    formula: "",
    amtFormula: "",
    align: "left",
  },
  {
    sno: "d",
    label: "House Rent Allowance",
    //subLabel: "",
    key: "hr",
    bold: "false",
    formula: "",
    amtFormula: "",
    align: "left",
  },
  {
    sno: "e",
    label: "C.C.A.",
    //subLabel: "",
    key: "ca",
    bold: "false",
    formula: "",
    amtFormula: "",
    align: "left",
  },
  {
    sno: "f",
    label: "Other Allowance",
    //subLabel: "",
    key: "toa",
    bold: "false",
    formula: "",
    amtFormula: "",
    align: "left",
  },
  {
    sno: "g",
    label: "Other Income",
    //subLabel: "",
    key: "an1",
    bold: "false",
    formula: "",
    amtFormula: "",
    align: "left",
  },

  {
    // sno: "h",
    // label: "Employer's Contribution (NPS)",
    // //subLabel: "",
    // key: "nps",
    // bold: "false",
    // formula: "",
    // amtFormula: "",
    // align: "left",

    sno: "h",
    label: "Employer's Contribution (NPS)",
    //subLabel: "",
    key: "emc",
    bold: "false",
    formula: "",
    amtFormula: "",
    align: "left",
  },
  {
    sno: "i",

    label: "Medical Reimbursement (Now Taxable)",
    //subLabel: "",
    key: "mr",
    bold: "false",
    formula: "",
    amtFormula: "",
    align: "left",
  },
  // {
  //   sno: "j",
  //   label: "Total Rent Paid To LandLord",
  //   //subLabel: "",
  //   key: "rp",
  //   bold: "false",
  //   formula: "",
  //   amtFormula: "",
  //   align: "left",
  // },
  {
    sno: "2",
    label: "Gross Salary",
    //subLabel: "(a TO i)",
    key: "gt",
    bold: "true",
    formula: "=SUM(D8:D16)",
    amtFormula: "",
    color: "FABF8F",
    align: "left",
    arr: ["ba", "gp", "da", "hr", "ca", "toi", "toa", "nps"],
  },
  {
    sno: "2(a)",
    label: "LESS : STANDARD DEDUCTION U/S 16(ia)",
    //subLabel: "",
    key: "LESS_STANDARD_DEDUCTION_US_16ia",
    bold: "true",
    formula: "=IF(D17<50000,D17,50000)",
    amtFormula: "",
    color: "FABF8F",
    align: "left",
  },
  {
    sno: "2(b)",
    label: "INCOME FROM SALARY",
    //subLabel: "{2-2(a)}",
    key: "INCOME_FROM_SALARY",
    bold: "true",
    formula: "=D17-D18",
    amtFormula: "=D19",
    color: "FABF8F",
    amtColor: "FABF8F",
    align: "left",
  },
  {
    sno: "3(a)",
    label: "LESS: HRA",
    //subLabel: "",
    key: "LESS_HRA",
    bold: "true",
    formula: "",
    amtFormula: "",
    align: "left",
  },
  {
    sno: "3(b)",
    label: "LESS:HOUSE LOAN INTEREST U/S 24(b) (upto Rs.2,00,000.00)",
    //subLabel: "",
    key: "LESS_HLI",
    bold: "true",
    formula: "",
    amtFormula: "",
    align: "left",
  },
  {
    sno: "4",
    label: "TOTAL OF COLUMN NO. 3",
    //subLabel: "",
    key: "TOTAL_OF_COLUMN_NO_3",
    bold: "true",
    formula: "=D20+D21",
    amtFormula: "=+D22",
    color: "FABF8F",
    amtColor: "FABF8F",
    align: "left",
  },
  {
    sno: "5",
    label: "NET SALARY",
    //subLabel: " (2 - 4)",
    key: "NET_SALARY",
    bold: "true",
    formula: "",
    amtFormula: "=E19-E22",
    amtColor: "FABF8F",
    align: "left",
  },
  {
    sno: "6",
    label: "ADD :-INCOME FROM OTHER SOURCES",
    //subLabel: "",
    key: "ADD :-INCOME FROM OTHER SOURCES",
    bold: "true",
    formula: "",
    amtFormula: "",
    align: "left",
  },
  {
    sno: "a",
    label: "Saving Interest",
    //subLabel: "",
    key: "si",
    bold: "false",
    formula: "",
    amtFormula: "",
    align: "left",
  },
  {
    sno: "b",
    label: "F.D.R. INTEREST",
    //subLabel: "",
    key: "fdi",
    bold: "false",
    formula: "",
    amtFormula: "",
    align: "left",
  },
  {
    sno: "c",
    label: "N.S.C. INTEREST",
    //subLabel: "",
    key: "nsci",
    bold: "false",
    formula: "",
    amtFormula: "",
    align: "left",
  },
  {
    sno: "d",
    label: "Family Pension Income",
    //subLabel: "",
    key: "family_pen_inc",
    bold: "false",
    formula: "",
    amtFormula: "",
    align: "left",
  },
  {
    sno: "e",
    label: "Any Other Income",
    //subLabel: "",
    key: "an1",
    bold: "false",
    formula: "",
    amtFormula: "",
    align: "left",
  },
  {
    sno: "7",
    label: "TOTAL OF COLUMN NO. 6",
    //subLabel: "(a + b + c + d)",
    key: "TOTAL_OF_COLUMN_NO_6",
    bold: "true",
    formula: "=SUM(D25:D28)",
    amtFormula: "=+D29",
    color: "FABF8F",
    amtColor: "FABF8F",
    align: "left",
  },
  {
    sno: "8",
    label: "TOTAL INCOME",
    //subLabel: "(6 + 7)",
    key: "TOTAL_INCOME",
    bold: "true",
    formula: "",
    amtFormula: "=E23+E29",
    amtColor: "FABF8F",
    align: "left",
  },
  {
    sno: "9",
    label:
      "DEDUCTION U/S 80CCE- (TOTAL OF SEC 80C+80CCC+80CCD(1) (UPTO RS. 1,50,000.00 LACS)",
    //subLabel: "",
    key: "DEDUCTION U/S 80CCE- (TOTAL OF SEC 80C+80CCC+80CCD(1) (UPTO RS. 1,50,000.00 LACS)",
    bold: "false",
    formula: "",
    amtFormula: "",
    align: "left",
  },
  {
    sno: "a",
    label: "G.P.F.",
    //subLabel: "",
    key: "gpf",
    bold: "false",
    formula: "",
    amtFormula: "",
    align: "left",
  },
  {
    sno: "b",
    label: "G.I.S.",
    //subLabel: "",
    key: "gis",
    bold: "false",
    formula: "",
    amtFormula: "",
    align: "left",
  },
  {
    sno: "c",
    label: "PPF",
    //subLabel: "",
    key: "ppf",
    bold: "false",
    formula: "",
    amtFormula: "",
    align: "left",
  },
  {
    sno: "d",
    label: "L.I.C.",
    //subLabel: "",
    key: "lic",
    bold: "false",
    formula: "",
    amtFormula: "",
    align: "left",
  },
  {
    sno: "e",
    label: "Tuition Fees",
    //subLabel: "",
    key: "tf",
    bold: "false",
    formula: "",
    amtFormula: "",
    align: "left",
  },
  {
    sno: "f",
    label: "House Loan Principle",
    //subLabel: "",
    key: "hp",
    bold: "false",
    formula: "",
    amtFormula: "",
    align: "left",
  },
  {
    sno: "g",
    label: "P.L.I.",
    //subLabel: "",
    key: "pi",
    bold: "false",
    formula: "",
    amtFormula: "",
    align: "left",
  },
  {
    sno: "h",
    label: "Term Insurance",
    //subLabel: "",
    key: "ti",
    bold: "false",
    formula: "",
    amtFormula: "",
    align: "left",
  },

  {
    sno: "i",
    label: "NPS - Employee Contribution U/S 80CCD(1)",
    //subLabel: "",
    key: "nps",
    bold: "false",
    formula: "",
    amtFormula: "",
    align: "left",
  },
  {
    sno: "j",
    label: "Any Other Deduction",
    //subLabel: "",
    key: "ad1",
    bold: "false",
    formula: "",
    amtFormula: "",
    align: "left",
  },
  {
    sno: "10",
    label: "TOTAL DEDUCTION U/S 80 C",
    //subLabel: "(a TO i)",
    key: "TOTAL_DEDUCTION_US80C",
    bold: "true",
    formula: "=IF((SUM(E32:E40))<150000,(SUM(E32:E40)),150000)",
    amtFormula: "",
    color: "FABF8F",
    align: "left",
  },
  {
    sno: "a",
    label: "Mediclame U/S 80D For Self",
    //subLabel: " (MAX- RS.25000.00) FOR S.C.50000.00",
    key: "med_for_self",
    bold: "false",
    formula: "",
    amtFormula: "",
    align: "left",
  },
  {
    sno: "b",
    label: "Mediclame U/S 80D For Family",
    //subLabel: " (MAX- RS.25000.00) FOR S.C.50000.00",
    key: "med_for_family",
    bold: "false",
    formula: "",
    amtFormula: "",
    align: "left",
  },
  // {
  //   sno: "b",
  //   label: "OTHER DEDUCTION --",
  //   //subLabel: "",
  //   key: "td",
  //   bold: "false",
  //   formula: "",
  //   amtFormula: "",
  //   align: "left",
  // },
  {
    sno: "c",
    label: "U/S 80DD (Medical Treatment of handicapped)",
    //subLabel: "(MAX. RS. 75000.00 or 1.25 lac)",
    key: "U/S_80DD",
    bold: "false",
    formula: "",
    amtFormula: "",
    align: "left",
  },
  {
    sno: "d",
    label: "U/S 80DDB Critical illness",
    //subLabel: "(MAX. RS. 40,000.00 For SC 1,00,000)",
    key: "U/S_80DDB",
    bold: "false",
    formula: "",
    amtFormula: "",
    align: "left",
  },
  {
    sno: "e",
    label: "U/S 80E Intt on loan taken for higher education",
    //subLabel: "(ONLY INTT AMOUNT) ",
    key: "80e",
    bold: "false",
    formula: "",
    amtFormula: "",
    align: "left",
  },
  {
    sno: "f",
    label: "U/S 80G DONATION",
    //subLabel: " (UPTO 10 % OF (SALARY minus U/S 80 C))",
    key: "U/S_80G",
    bold: "false",
    formula: "",
    amtFormula: "",
    align: "left",
  },
  {
    sno: "g",
    label:
      "U/S 80TTA (SB INTT UPTO 10000.00) or 80TTB (FOR S.CITIZEN UPTO 50000)",
    //subLabel: "",
    key: "U/S_80TTA",
    bold: "false",
    formula: `=IF(OR(E1="SENIOR CITIZEN",E1="SUPER SENIOR CITIZEN"),IF((D25+D26)>=50000,50000,(D25+D26)),IF(D25>=10000,10000,D25))`,
    color: "FABF8F",
    amtFormula: "",
    align: "left",
  },
  {
    sno: "h",
    label: "U/S 80TTB",
    //subLabel: "(RS. 75000.00 & MAX  RS. 1.25 LACS)",
    key: "U/S_80TTB",
    bold: "false",
    formula: "",
    amtFormula: "",
    align: "left",
  },
  {
    sno: "i",
    label: "U/S 80U Handicapped/Blind",
    //subLabel: "(RS. 75000.00 & MAX  RS. 1.25 LACS)",
    key: "U/S_80U",
    bold: "false",
    formula: "",
    amtFormula: "",
    align: "left",
  },
  {
    sno: "j",
    label: "U/S 80CCD(2) NPS Paid by Employer",
    //subLabel: "(UPTO 14 % OF SALARY)",
    key: "U/S_80CCD(2)",
    bold: "false",
    formula: "",
    amtFormula: "",
    labelColor: "FABF8F",
    subLabelColor: "FABF8F",
    align: "left",
  },
  {
    sno: "k",
    label: "U/S 80CCD(1B) NPS (New Pension Scheme)",
    //subLabel: "(UPTO 50000.00)",
    key: "U/S_80CCD(1B)",
    bold: "false",
    formula: "",
    amtFormula: "",
    align: "left",
  },
  {
    sno: "l",
    label: "U/S 80 CCH(2) Central Government To Agniveer",
    //subLabel: "(UPTO 50000.00)",
    key: "80cch2",
    bold: "false",
    formula: "",
    amtFormula: "",
    align: "left",
  },
  {
    sno: "11",
    label: "TOTAL DEDUCTION",
    //subLabel: "10 + (a TO g)",
    key: "TOTAL_DEDUCTION",
    bold: "true",
    formula: "=SUM(D41:D51)",
    amtFormula: "=+D52",
    color: "FABF8F",
    amtColor: "FABF8F",
    align: "left",
  },
  {
    sno: "12",
    label: "TAXABLE INCOME",
    //subLabel: "(8 - 11)",
    key: "TAXABLE_INCOME",
    bold: "true",
    formula: "",
    amtFormula: "=E30-E52",
    amtColor: "FABF8F",
    align: "left",
  },
  {
    sno: "13",
    label: "COMPUTATION OF TAX",
    //subLabel: "",
    key: "COMPUTATION_OF_TAX",
    bold: "true",
    formula: `=ROUND((IF(E1="Male",IF(E53<=250000,0,IF(E53<=500000,((E53-250000)*5%),IF(E53<=1000000,((E53-500000)*20%+12500),((E53-1000000)*30%+112500)))),IF(E1="FEMALE",IF(E53<=250000,0,IF(E53<=500000,((E53-250000)*5%),IF(E53<=1000000,((E53-500000)*20%+12500),((E53-1000000)*30%+112500)))),IF(E1="SENIOR CITIZEN",IF(E53<=300000,0,IF(E53<=500000,((E53-300000)*5%),IF(E53<=1000000,((E53-500000)*20%+10000),((E53-1000000)*30%+110000)))),IF(E1="SUPER SENIOR CITIZEN",IF(E53<=500000,0,IF(E53<=1000000,((E53-500000)*20%),IF(E53<=10000000,((E53-1000000)*30%+100000),0)))))))),0)`,
    amtFormula: "",
    color: "FABF8F",
    align: "left",
  },
  {
    sno: "",
    label:
      "UPTO RS 2,50,000.00 FOR MALE & FEMALE, S.C. Rs. 3 LACS & SUPER S.C. Rs. 5 LACS)",
    //subLabel: "",
    key: "UPTO RS 2,50,000.00 FOR MALE & FEMALE, S.C. Rs. 3 LACS & SUPER S.C. Rs. 5 LACS)",
    bold: "false",
    formula: "",
    amtFormula: "",
    align: "left",
  },
  {
    sno: "",
    label: "RS. 2,50,001.00 TO 5,00,000.00 UPTO 5%",
    //subLabel: "",
    key: "RS. 2,50,001.00 TO 5,00,000.00 UPTO 5%",
    bold: "false",
    formula: "",
    amtFormula: "",
    align: "left",
  },
  {
    sno: "",
    label: "RS. 5,00,001.00 TO 10,00,000.00 UPTO 20%",
    //subLabel: "",
    key: "RS. 5,00,001.00 TO 10,00,000.00 UPTO 20%",
    bold: "false",
    formula: "",
    amtFormula: "",
    align: "left",
  },
  {
    sno: "",
    label: "RS. 10,00,001 TO ABOVE 30%",
    //subLabel: "",
    key: "RS. 10,00,001 TO ABOVE 30%",
    bold: "false",
    formula: "",
    amtFormula: "",
    align: "left",
  },
  {
    sno: "14",
    label: "TAX PAYABLE ",
    //subLabel: "",
    key: "TAX_PAYABLE",
    bold: "true",
    formula: "=D54",
    amtFormula: "",
    color: "FABF8F",
    align: "left",
  },
  {
    sno: "15",
    label: "SURCHARGE",
    //subLabel: "",
    key: "SURCHARGE",
    bold: "true",
    formula: "",
    amtFormula: "",
    color: "FABF8F",
    align: "left",
  },
  {
    sno: "16",
    label: "LESS: REBATE U/S 87A",
    //subLabel: "",
    key: "LESS_REBATE_US_87A",
    bold: "true",
    formula: `=ROUND((IF((E53>500000),0,IF(OR(E1="MALE",F1="FEMALE"),IF(E53<=250000,0,IF(((E53-250000)*5%)>=12500,12500,(E53-250000)*5%)),IF(E1="SENIOR CITIZEN",IF(E53<=300000,0,IF(((E53-300000)*5%)<=12500,(E53-300000)*5%,(E3-300000)*5%)),0)))),0)`,
    amtFormula: "",
    color: "FABF8F",
    align: "left",
  },
  {
    sno: "17",
    label: "NET TAX PAYABLE ",
    //subLabel: " (14 - 15)",
    key: "NET_TAX_PAYABLE",
    bold: "true",
    formula: "=IF(D59<=D60,0,(D59-D60))",
    amtFormula: "",
    color: "FABF8F",
    align: "left",
  },
  {
    sno: "a",
    label: "HEALTH AND EDUCATION CESS @4%",
    //subLabel: "",
    key: "HEALTH_AND_EDUCATION_CESS",
    bold: "false",
    formula: "=ROUND((D61*4/100),0)",
    amtFormula: "",
    color: "FABF8F",
    align: "left",
  },
  {
    sno: "18",
    label: "TOTAL TAX PAYABL",
    //subLabel: "(16 + a + b)",
    key: "TOTAL_TAX_PAYABL",
    bold: "true",
    formula: "=D61+D62",
    amtFormula: "=+D63",
    color: "FABF8F",
    amtColor: "FABF8F",
    align: "left",
  },
  {
    sno: "19",
    label: "RELIEF U/S 89 (1)",
    //subLabel: "",
    key: "RELIEF U/S 89 (1)",
    bold: "false",
    formula: "",
    amtFormula: "",
    align: "left",
  },
  {
    sno: "20",
    label: "TOTAL TAX PAYABLE AFTER RELIEF OF U/S 89 ( I ) ",
    //subLabel: " (17 - 18)",
    key: "TOTAL_TAX_PAYABLE_AFTER_RELIEF_OF_US_89",
    bold: "true",
    formula: "",
    amtFormula: "=E63-E64",
    amtColor: "FABF8F",
    align: "left",
  },
  {
    sno: "21",
    label: "TAX DEDUCTED AT SOURCE (i.e. DEDUCTED BY DEPT.)",
    //subLabel: "",
    key: "TAX_DEDUCTED_AT_SOURCE",
    bold: "false",
    formula: "",
    amtFormula: "it",
    align: "left",
  },
  {
    sno: "22",
    label: "NET TAX PAYABLE/ (REFUNDABLE)",
    //subLabel: "(19-20)",
    key: "NET_TAX_PAYABLE_REFUNDABLE",
    bold: "true",
    formula: "",
    amtFormula: "=E65-E66",
    align: "left",
  },
  {
    sno: "23",
    label: "",
    //subLabel: "(19-20)",
    key: "ec",
    bold: "true",
    formula: "",
    amtFormula: "",
    align: "left",
  },
  {
    sno: "24",
    label: "",
    //subLabel: "(19-20)",
    key: "ed",
    bold: "true",
    formula: "",
    amtFormula: "",
    align: "left",
  },
];
